// 版本配置，专业版1，企业版2
export const versionConfig = [
  { value: -1, text: '试用版' },
  { value: 3, text: '专业版' },
  { value: 4, text: '企业版' }
];

export const allVersionConfig = [
  { value: 1, text: '体验版' },
  { value: -1, text: '试用版' },
  { value: 2, text: '标准版' },
  { value: 3, text: '专业版' },
  { value: 4, text: '企业版' },
  { value: 1002, text: '体验版' },
  { value: 1001, text: '试用版' },
  { value: 1003, text: '专业版' },
  { value: 1004, text: '企业版' }
];

export const newVersionConfig = [
  { value: 1001, text: '试用版' },
  { value: 1003, text: '专业版' },
  { value: 1004, text: '企业版' }
];
